var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5107_139155)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 24C20.866 24 24 20.866 24 17C24 13.134 20.866 10 17 10C13.134 10 10 13.134 10 17C10 20.866 13.134 24 17 24ZM17 23C20.3137 23 23 20.3137 23 17C23 13.6863 20.3137 11 17 11C13.6863 11 11 13.6863 11 17C11 20.3137 13.6863 23 17 23Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.875C0 0.909091 0.897772 0 1.81818 0H18.1818C19.1022 0 20 0.909091 20 1.81818V10.6736C19.7076 10.5347 19.404 10.4155 19.0909 10.3176V1.81818C19.0909 1.36364 18.6364 0.909091 18.1818 0.909091H1.81818C1.36364 0.909091 0.909091 1.36364 0.909091 1.81818V18.1818C0.909091 18.6364 1.36364 19.0909 1.81818 19.0909H10.3176C10.4155 19.404 10.5347 19.7076 10.6736 20H1.81818C0.909091 20 0 19.1023 0 18.1818V1.875Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1818 10.0993C17.7976 10.034 17.4028 10 17 10C15.7679 10 14.6101 10.3183 13.6045 10.8772L12.7273 10L10.9091 11.8182L8.18182 8.18182L1.81818 15.4545V2.72727C1.81818 2.27273 2.27273 1.81818 2.72727 1.81818H17.2727C17.7273 1.81818 18.1818 2.27273 18.1818 2.72727V10.0993ZM14.375 6.875C15.4105 6.875 16.25 6.03553 16.25 5C16.25 3.96447 15.4105 3.125 14.375 3.125C13.3395 3.125 12.5 3.96447 12.5 5C12.5 6.03553 13.3395 6.875 14.375 6.875Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18L17 22L13 18H15V13H19V18H21Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5107_139155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveImage);
export default __webpack_public_path__ + "static/media/SaveImage.9654497b7b1df905966bad9c043bdf1d.svg";
export { ForwardRef as ReactComponent };